import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Card } from 'antd';
import { nanoid } from 'nanoid';
import { txt } from 'libs/i18n';
import { getCurrentUiLocale } from 'libs/locales/ui';
import * as UserlexAPI from 'api/userlex-api';
import { fetchTranscriptionProfiles, extractLanguagesFromProfiles } from 'api/user-api';
import DashboardPage from 'screens/DashboardScreen/components/DashboardPage';
import { useSession } from 'components/Authenticated';
import Loading from 'components/Loading';
import AlertPage from '../AlertPage';
import UserlexToolbar from './UserlexToolbar';
import UserlexTable from './UserlexTable';
import UserlexModal from './UserlexModal';
const emptyEntry = () => ({
    correctTranscription: '',
    incorrectTranscription: '',
    key: nanoid(),
});
const UserlexPage = () => {
    const { session } = useSession();
    const [userlex, setUserlex] = useState('loading');
    const [modal, setModal] = useState({
        action: 'add',
        visible: false,
        initialValues: emptyEntry(),
    });
    useEffect(() => {
        const loadUserlex = async () => {
            const profilesResult = await fetchTranscriptionProfiles(session.connection);
            if (profilesResult.isFail()) {
                setUserlex('error');
                return;
            }
            const profiles = profilesResult.get();
            const availableLanguages = extractLanguagesFromProfiles(profiles);
            const selectedLang = getCurrentUiLocale();
            const result = await UserlexAPI.fetchCurrentUserlex(session.connection, selectedLang);
            if (result.isSuccess()) {
                setUserlex({
                    locales: availableLanguages,
                    entries: result.get(),
                    selectedLang,
                });
            }
            else {
                setUserlex('error');
            }
        };
        void loadUserlex();
    }, []);
    if (userlex === 'loading') {
        return (_jsx(DashboardPage, { title: txt('userlex'), children: _jsx(Loading, {}) }));
    }
    if (userlex === 'error') {
        return (_jsx(AlertPage, { title: txt('error'), header: txt('error'), children: _jsx("p", { children: txt('noTranscriptionOptions') }) }));
    }
    const openAddModal = () => {
        setModal({ action: 'add', visible: true, initialValues: emptyEntry() });
    };
    const openEditModal = (record) => {
        setModal({ action: 'edit', visible: true, initialValues: record });
    };
    return (_jsx(DashboardPage, { title: txt('userlex'), children: ({ contentHeight }) => (_jsx("section", { children: _jsxs(Card, { bordered: false, children: [_jsx(UserlexToolbar, { onAdd: openAddModal, userlex: userlex, setUserlex: setUserlex }), _jsx(UserlexTable, { userlex: userlex, setUserlex: setUserlex, contentHeight: contentHeight, onOpenEdit: openEditModal }), _jsx(UserlexModal, { modal: modal, setModal: setModal, userlex: userlex, setUserlex: setUserlex })] }) })) }));
};
export default UserlexPage;
